import pages from './pages'
import forms from './forms'
import options from './options'
import map from './map'

export default {
  pages: pages,
  forms: forms,
  options: options,
  map: map,
  el: {
    pagination: {
      total: 'Total {total}',
      pagesize: '/page'
    },
    select: {
      noData: 'Aucune donnée'
    }
  }
}



// WEBPACK FOOTER //
// ./src/lang/fr_FR/index.js